<template>
  <div class="home">
    <h1>
      WORK IN PROGRES
    </h1>
  </div>
</template>

<script>
// @ is an alias to /src

export default {
  name: "Home"
};
</script>
